export default __webpack_public_path__ + "static/media/pay-order-yellow.2601d76f.svg";